import {
    SETTINGS_LOAD_REQUEST,
    SETTINGS_LOAD_SUCCESS,
    SETTINGS_LOAD_ERROR,
} from 'state/actions/settings'

export const initialState = {
    craftMachineUrl: '',
    wgshEventsUrl: '',
    wgshEventsApiUrl: '',
    isCNRealm: false,
    isInGameBrowser: (window.jsHostQuery !== undefined),
    loading: false,
    loaded: false,
    realm: null,
    pushStreamHost: null,
    errorMessage: '',
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case SETTINGS_LOAD_REQUEST: {
        return {
            ...state,
            loaded: false,
            loading: true,
            errorMessage: '',
        }
    }
    case SETTINGS_LOAD_ERROR: {
        return {
            ...state,
            loaded: false,
            loading: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case SETTINGS_LOAD_SUCCESS: {
        const {
            craftMachineUrl,
            pushStreamHost,
            realm,
            backendHost,
            gatewayHost,
            globalMapUrl,
            clanQuestsUrl,
            clanCreateUrl,
            showClanQuestsCard,
            strongholdSettings,
            iconUrlTemplates,
            signInTokenUrl,
            wgcmpBillboardUrl,
            wgcmpBillboardNewMessageUrl,
            industrialResourceMultiplier,
            clanSlides,
            clanEntranceCooldown,
            wgshEventsUrl,
            wgshEventsApiUrl,
        } = action.payload

        return {
            ...state,
            ...strongholdSettings,
            craftMachineUrl,
            iconUrlTemplates,
            realm,
            isCNRealm: realm === 'cn360',
            pushStreamHost,
            backendHost,
            gatewayHost,
            globalMapUrl,
            clanQuestsUrl,
            clanCreateUrl,
            showClanQuestsCard,
            signInTokenUrl,
            wgcmpBillboardUrl,
            wgcmpBillboardNewMessageUrl,
            industrialResourceMultiplier,
            clanSlides,
            clanEntranceCooldown,
            wgshEventsUrl,
            wgshEventsApiUrl,
            loading: false,
            loaded: true,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/settings.js